// AdminSidebar.js
import React, { useState, useEffect } from "react";
import SidebarItem from "../components/SidebarItem";
import "../css/SidebarItem.css";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setSelectedMenu } from "../redux/sidebarSlice";
import botIcon from "../assets/icons/botIcon.png";
import DashboardIcon from "../assets/icons/dashboardIcon.png";
import UserIcon from "../assets/icons/users.png";
import ActivityLogIcon from "../assets/icons/activity-log.png";
import FileIcon from "../assets/icons/TrainDoc.png";
import TextIcon from "../assets/icons/TrainText.png";
import LinkIcon from "../assets/icons/TrainUrl.png";
import YoutubeIcon from "../assets/icons/TrainVideo.png";
import FolderNav from "../assets/Images/FolderNav1.png";
import EnterpriseIcon from "../assets/icons/enterprisesvg.png";
import DepartmentIcon from "../assets/icons/departmentw.svg";
import QAIcon from "../assets/icons/TrainQA.png";
import ConversionIcon from "../assets/icons/convIcon.png";
import TrainingIcon from "../assets/icons/train-doc-icon.png";
import UploadIcon from "../assets/icons/filesvg.png";
import TrainIcon from "../assets/icons/TrainDocHistory.png";

import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import VelaKoda from "../assets/Images/LoginLogo.svg";
import VelaLogo from "../assets/Images/ZeroBoxLogo.svg";

import api from "../api";
const BASE_URL = `${process.env.REACT_APP_API_URL}/version-history`;

const AdminSidebar = ({ expanded, toggleSidebar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const selectedMenu = useSelector((state) => state.sidebar.selectedMenu);
  const [versions, setVersions] = useState([]);

  const handleMenuClick = (label) => {
    dispatch(setSelectedMenu(label));
  };

  useEffect(() => {
    // Map path → menu name
    const pageLabelsMap = {
      "/admin/dashboard": "Dashboard",
      "/admin/notifications": "Notifications",
      "/admin/profile": "Profile Settings",
      "/admin/getHelpPage": "Get Help",
      "/admin/conversation-management":
        "Conversation Management - Monitor, review, and manage all user conversations.",
      "/admin/chat-usage-management":
        "Conversation Management - Monitor, review, and manage all user conversations.",
      "/admin/user-session-management":
        "Conversation Management - Monitor, review, and manage all user conversations.",
      "/admin/enterprize-managements":
        "Enterprize Management - Manage enterprize accounts, settings, and configurations.",
      "/admin/enterprize-setting":
        "Enterprize Settings - Manage enterprize accounts, settings, and configurations.",
      "/admin/user-management":
        "User Management - Add, update, and manage all system users.",
      "/admin/training-files":
        "Documents - Upload and manage all training-related documents.",
      "/admin/training-text":
        "Texts - Upload and manage text-based training content.",
      "/admin/training-website":
        "Web URLs - Add web links used for admin training.",
      "/admin/training-qa":
        "QnA - Create and maintain question–answer training material.",
      "/admin/training-youtube":
        "Video URLs - Upload and manage video links for admin training.",
      "/admin/uploaded-docs": "Uploaded Documents",
      "/admin/knowledge-repository":
        "Knowledge Repository - Central storage for all documents and resources for the enterprize.",
      "/admin/knowledge-repo-urls":
        "Knowledge Repository - Central storage for all documents and resources for the enterprize.",
      "/admin/knowledge-repo-text":
        "Knowledge Repository - Central storage for all documents and resources for the enterprize.",
      "/admin/knowledge-repo-video":
        "Knowledge Repository - Central storage for all documents and resources for the enterprize.",
      "/admin/knowledge-repo-qa":
        "Knowledge Repository - Central storage for all documents and resources for the enterprize.",

      "/admin/repo-organizer":
        "Repository Organizer - Manage, move, and organize repository files efficiently.",

      "/admin/trace-logs": "Trace Logs",
      "/admin/performance-logs": "Performance Logs",
      "/admin/group-management":
        "Group Management - Manage groups and their configurations.",
    };

    const currentPath = pageLabelsMap[location.pathname] || "";

    // Update redux only if changed
    if (selectedMenu !== currentPath) {
      dispatch(setSelectedMenu(currentPath));
    }
  }, [location.pathname, dispatch, selectedMenu]);

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const fetchVersions = async () => {
    if (!token) {
      showErrorToast(TOAST_MESSAGES.UNAUTHORIZED);
      return;
    }
    try {
      const response = await api.get(BASE_URL, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setVersions(response.data);
    } catch (error) {
      console.error("Failed to fetch versions", error);
      //   showErrorToast(TOAST_MESSAGES.VERSION.FETCH_ERROR);
    }
  };

  useEffect(() => {
    fetchVersions();
  }, []);

  const handleLogoClick = () => {
    navigate("/"); // navigate to login page
  };

  return (
    <div
      className={`sidebar d-flex flex-column justify-content-between ${
        expanded ? "expanded" : "collapsed"
      }`}
      style={{ height: "100vh" }}
    >
      {/* Top Section */}
      <div>
        <div
          className={`logo-section ${
            expanded
              ? "d-flex justify-content-between align-items-center px-3"
              : "d-flex align-items-center justify-content-center gap-2 py-2"
          }`}
        >
          {expanded ? (
            <>
              <img
                src={VelaKoda}
                alt="Logo"
                className="logo"
                style={{ width: "160px", height: "30px", objectFit: "contain" }}
                onClick={handleLogoClick}
              />
              <button
                onClick={() => {
                  toggleSidebar();
                  // handleLogoClick();
                }}
                className="sidebar-toggler ms-2"
              >
                <i className="bi bi-chevron-double-left" />
              </button>
            </>
          ) : (
            <>
              <img
                src={VelaLogo}
                alt="Bot Icon"
                className="bot-icon W-50"
                style={{ width: "28px", height: "28px", cursor: "pointer" }}
                onClick={() => {
                  // toggleSidebar();
                  handleLogoClick();
                }}
              />
              <button onClick={toggleSidebar} className="sidebar-toggler">
                <i className="bi bi-chevron-double-right" />
              </button>
            </>
          )}
        </div>
        {/* <div
          className={`logo-section ${
            expanded
              ? "d-flex justify-content-between align-items-center px-3"
              : "d-flex align-items-center justify-content-center gap-2 py-2"
          }`}
        >
          {expanded ? (
            <>
              <img
                src={VelaKoda}
                alt="Logo"
                className="logo"
                style={{
                  width: "160px",
                  height: "30px",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
                onClick={handleLogoClick}
              />
              <button onClick={toggleSidebar} className="sidebar-toggler ms-2">
                <i className="bi bi-chevron-double-left" />
              </button>
            </>
          ) : (
            <>
              <img
                src={VelaLogo}
                alt="Bot Icon"
                className={`bot-icon w-50 ${
                  expanded ? "expanded" : "collapsed"
                }`}
                style={{ cursoer: "pointer" }}
                onClick={handleLogoClick}
              />
              <button
                onClick={toggleSidebar}
                className={`sidebar-toggler ${
                  expanded ? "expanded" : "collapsed"
                }`}
              >
                <i className="bi bi-chevron-double-right" />
              </button>
            </>
          )}
        </div> */}

        {/* Menu Items */}
        <ul className="menu">
          <SidebarItem
            icon={DashboardIcon}
            label="Dashboard"
            to="/admin/dashboard"
            expanded={expanded}
            onClick={() => handleMenuClick("Dashboard")}
            active={selectedMenu === "Dashboard"}
          />
          {/* <SidebarItem
            icon={UploadIcon}
            label="Uploaded Documents"
            to="/admin/uploaded-docs"
            expanded={expanded}
            onClick={() => handleMenuClick("Uploaded Documents")}
            active={selectedMenu === "Uploaded Documents"}
          /> */}

          <SidebarItem
            icon={TrainIcon}
            label="Knowledge Repository"
            to="/admin/knowledge-repository"
            expanded={expanded}
            onClick={() => handleMenuClick("Knowledge Repository")}
            active={
              selectedMenu ===
              "Knowledge Repository - Central storage for all documents and resources for the enterprize."
            }
          />

          <SidebarItem
            icon={FolderNav}
            label="Repository Organizer"
            to="/admin/repo-organizer"
            expanded={expanded}
            onClick={() => handleMenuClick("Repository Organizer")}
            active={
              selectedMenu ===
              "Repository Organizer - Manage, move, and organize repository files efficiently."
            }
          />

          <SidebarItem
            icon={TrainingIcon}
            label="Training Studio"
            expanded={expanded}
            active={selectedMenu === "Training"}
            onClick={() => handleMenuClick("Training")}
            subItems={[
              {
                label: "Documents",
                to: "/admin/training-files",
                className: "sidebar-label-files",
                icon: (
                  <img
                    src={FileIcon}
                    alt="icon"
                    className="me-2 icon-image1 fs-small"
                    style={{
                      width: "16px",
                      height: "16px",
                      filter: "brightness(0) invert(1)",
                    }}
                  />
                ),
                onClick: () => handleMenuClick("Documents"),
                active:
                  selectedMenu ===
                  "Documents - Upload and manage all training-related documents.",
              },
              {
                label: "Texts",
                to: "/admin/training-text",
                icon: (
                  <img
                    src={TextIcon}
                    alt="icon"
                    className="me-2 icon-image"
                    style={{
                      width: "16px",
                      height: "16px",
                      filter: "brightness(0) invert(1)", // ✅ White icon
                    }}
                  />
                ),
                onClick: () => handleMenuClick("Text"),
                active:
                  selectedMenu ===
                  "Texts - Upload and manage text-based training content.",
              },
              {
                label: "Web URLs",
                to: "/admin/training-website",
                icon: (
                  <img
                    src={LinkIcon}
                    alt="icon"
                    className="me-2 icon-image"
                    style={{
                      width: "16px",
                      height: "16px",
                      filter: "brightness(0) invert(1)", // ✅ White icon
                    }}
                  />
                ),
                onClick: () => handleMenuClick("Web URLs"),
                active:
                  selectedMenu ===
                  "Web URLs - Add web links used for admin training.",
              },
              {
                label: "Q&A",
                to: "/admin/training-qa",
                icon: (
                  <img
                    src={QAIcon}
                    alt="icon"
                    className="me-2 icon-image"
                    style={{
                      width: "16px",
                      height: "16px",
                      filter: "brightness(0) invert(1)", // ✅ White icon
                    }}
                  />
                ),
                onClick: () => handleMenuClick("Q&A"),
                active:
                  selectedMenu ===
                  "QnA - Create and maintain question–answer training material.",
              },
              {
                label: "Video URLs",
                to: "/admin/training-youtube",
                icon: (
                  <img
                    src={YoutubeIcon}
                    alt="icon"
                    className="me-2 icon-image"
                    style={{
                      width: "16px",
                      height: "16px",
                      filter: "brightness(0) invert(1)", // ✅ White icon
                    }}
                  />
                ),
                onClick: () => handleMenuClick("Video URLs"),
                active:
                  selectedMenu ===
                  "Video URLs - Upload and manage video links for admin training.",
              },
            ]}
          />

          <SidebarItem
            icon={UserIcon}
            label="User Management"
            to="/admin/user-management"
            expanded={expanded}
            onClick={() => handleMenuClick("User Management")}
            active={
              selectedMenu ===
              "User Management - Add, update, and manage all system users."
            }
          />

          <SidebarItem
            icon={ConversionIcon}
            label="Conversation Management"
            to="/admin/conversation-management"
            expanded={expanded}
            onClick={() => handleMenuClick("Conversation Management")}
            active={
              selectedMenu ===
              "Conversation Management - Monitor, review, and manage all user conversations."
            }
          />

          <SidebarItem
            icon={DepartmentIcon}
            label="Group Management"
            to="/admin/group-management"
            expanded={expanded}
            onClick={() => handleMenuClick("Group Management")}
            active={
              selectedMenu ===
              "Group Management - Manage groups and their configurations."
            }
          />

          <SidebarItem
            icon={EnterpriseIcon}
            label="Enterprize Management"
            to="/admin/enterprize-managements"
            expanded={expanded}
            onClick={() => handleMenuClick("Enterprize Management")}
            active={
              selectedMenu ===
              "Enterprize Management - Manage enterprize accounts, settings, and configurations."
            }
          />

          <SidebarItem
            icon={ActivityLogIcon}
            label="Trace Logs"
            to="/admin/trace-logs"
            expanded={expanded}
            onClick={() => handleMenuClick("Trace Logs")}
            active={selectedMenu === "Trace Logs"}
          />

          {/* <SidebarItem
            icon={ActivityLogIcon}
            label="Performance Logs"
            to="/admin/performance-logs"
            expanded={expanded}
            onClick={() => handleMenuClick("Performance Logs")}
            active={selectedMenu === "Performance Logs"}
          /> */}
        </ul>
      </div>

      {/* <div
        className="text-center"
        style={{ color: "white", cursor: "pointer" }}
      >
        <p
          style={{ fontSize: "small" }}
          onClick={() => {
            navigate("/superadmin/version-management");
            dispatch(setSelectedMenu("Version Management"));
          }}
        >
          v1.1.9
        </p>
      </div> */}

      <div className="text-center c tooltip1" style={{ color: "white" }}>
        {versions.length > 0 && (
          <>
            <p
              className="ak-text-sm"
              // onClick={() => {
              //   navigate("/superadmin/version-management");
              //   dispatch(setSelectedMenu("Version Management"));
              // }}
            >
              {versions[0].version_number}
            </p>

            <span className="tooltip1text">
              <table className="tooltip-table">
                <thead>
                  <tr>
                    <th>Version</th>
                    <th>Release Date</th>
                    <th>Changes</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {versions.map((v) => (
                    <tr key={v.id}>
                      <td>v{v.version_number}</td>
                      <td>
                        {v.version_release_date
                          ? new Date(
                              v.version_release_date
                            ).toLocaleDateString()
                          : "-"}
                      </td>
                      <td>{v.version_changes || "—"}</td>
                    </tr>
                  ))} */}
                  {versions.length > 0 &&
                    (() => {
                      const v = versions[0];
                      return (
                        <tr key={v.id}>
                          <td>v{v.version_number}</td>
                          <td>
                            {v.version_release_date
                              ? new Date(
                                  v.version_release_date,
                                ).toLocaleDateString()
                              : "-"}
                          </td>
                          <td>{v.version_changes || "—"}</td>
                        </tr>
                      );
                    })()}
                </tbody>
              </table>
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminSidebar;
